import './index.css';
import { createContext, useContext } from 'react';

const LayoutContext = createContext({
    leftSidebarEnabled: false,
    rightSidebarEnabled: false,
});
const useLayoutContext = () => useContext(LayoutContext);

export { LayoutContext, useLayoutContext };
//# sourceMappingURL=layoutContext.js.map
